<template>
  <footer class="py-24 bg-premium-bg border-t border-premium-border/30 relative overflow-hidden">
    <!-- Subtle Background Glow -->
    <div class="absolute -bottom-24 left-1/2 -translate-x-1/2 w-[600px] h-[300px] bg-brand-500/5 blur-[100px] rounded-full pointer-events-none"></div>

    <div class="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-12 mb-20">
        <!-- Brand Section -->
        <div class="lg:col-span-2">
          <router-link
            :to="isLoggedIn ? '/dashboard' : '/'"
            class="flex items-center space-x-3 mb-6 group"
          >
            <div class="w-10 h-10 rounded-xl bg-premium-card border border-premium-border/50 flex items-center justify-center group-hover:border-brand-500/50 transition-colors">
              <img
                src="@/assets/ideascope-new-logo-without-bg.png"
                alt="IdeaScope Logo"
                class="w-6 h-6 object-contain"
              />
            </div>
            <h1 class="text-2xl font-black italic uppercase tracking-tighter">
              Idea<span class="text-brand-400">Scope</span>
            </h1>
          </router-link>
          <p class="text-premium-text/40 text-sm font-medium leading-relaxed max-w-xs uppercase tracking-wider">
            Surgical market intelligence for modern founders. Decode complexity, validate vision, and scale with confidence.
          </p>
        </div>

        <!-- Navigation Links -->
        <div>
          <h4 class="text-[10px] font-black uppercase tracking-[0.2em] text-premium-text/30 mb-6">Product</h4>
          <ul class="space-y-4">
            <li v-for="link in productLinks" :key="link.name">
              <a :href="link.href" class="text-sm font-bold text-premium-text/50 hover:text-brand-400 transition-colors duration-200">
                {{ link.name }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 class="text-[10px] font-black uppercase tracking-[0.2em] text-premium-text/30 mb-6">Company</h4>
          <ul class="space-y-4">
            <li v-for="link in companyLinks" :key="link.name">
              <a :href="link.href" class="text-sm font-bold text-premium-text/50 hover:text-brand-400 transition-colors duration-200">
                {{ link.name }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 class="text-[10px] font-black uppercase tracking-[0.2em] text-premium-text/30 mb-6">Resources</h4>
          <ul class="space-y-4">
            <li v-for="link in resourceLinks" :key="link.name">
              <a :href="link.href" class="text-sm font-bold text-premium-text/50 hover:text-brand-400 transition-colors duration-200">
                {{ link.name }}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 class="text-[10px] font-black uppercase tracking-[0.2em] text-premium-text/30 mb-6">Legal</h4>
          <ul class="space-y-4">
            <li v-for="link in legalLinks" :key="link.name">
              <a :href="link.href" class="text-sm font-bold text-premium-text/50 hover:text-brand-400 transition-colors duration-200">
                {{ link.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div class="pt-8 border-t border-premium-border/10 flex flex-col md:flex-row justify-between items-center gap-6">
        <div class="text-[10px] font-black uppercase tracking-[0.2em] text-premium-text/20">
          © {{ new Date().getFullYear() }} IdeaScope Protocol. All rights reserved.
        </div>

        <!-- Social Icons -->
        <div class="flex items-center gap-4">
          <a
            v-for="social in socialLinks"
            :key="social.name"
            :href="social.href"
            class="w-10 h-10 rounded-lg bg-premium-card border border-premium-border/50 flex items-center justify-center text-premium-text/40 hover:text-brand-400 hover:border-brand-400/30 hover:bg-brand-400/5 transition-all duration-300"
            :aria-label="social.name"
          >
            <component :is="social.icon" class="w-4 h-4" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { Mail, Twitter, Linkedin } from "lucide-vue-next";

export default {
  name: "AppFooter",
  components: {
    Mail,
    Twitter,
    Linkedin,
  },
  data() {
    return {
      productLinks: [
        { name: "Features", href: "/features" },
        { name: "Pricing", href: "/pricing" },
        { name: "Intelligence", href: "/how-it-works" },
      ],
      companyLinks: [
        { name: "About", href: "/about" },
        { name: "Founders", href: "/about" },
        { name: "Contact", href: "/contact" },
      ],
      resourceLinks: [
        { name: "FAQ", href: "/faq" },
        { name: "Support", href: "/contact" },
        { name: "Methods", href: "/how-it-works" },
      ],
      legalLinks: [
        { name: "Terms", href: "/terms" },
        { name: "Privacy", href: "/privacy" },
        { name: "Refunds", href: "/refund" },
      ],
      socialLinks: [
        { name: "Email", href: "mailto:abdulmannan.khan005@gmail.com", icon: Mail },
        { name: "Twitter", href: "https://x.com/aMannanK2005", icon: Twitter },
        { name: "LinkedIn", href: "https://www.linkedin.com/in/amannankhan/", icon: Linkedin },
      ],
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.isUserLoggedIn;
    },
  },
};
</script>

<style scoped>
/* No additional styles needed as we use Tailwind */
</style>
